export default "__VITE_ASSET__CS5jS1nr__"